import {
	KDataTable,
	KDataTableMenu,
	KPdfDialog
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";
import { formatDate, formatTime } from "kinnect-formatters";

export default KDataTable.extend( {
	name: "KEmployeeInjuryReportsTable",

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no reports to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching reports found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "created_at"
		},

		sortDesc: {
			...KDataTable.options.props.sortDesc,
			default: true
		}
	},

	computed: {
		defaultHeaders() {
			return [
				{
					text: "Date of Report",
					value: "created_at"
				},
				{
					text: "Employee",
					value: "employee.name"
				},
				{
					text: "Date of injury",
					value: "injuryDate"
				},
				{
					text: "Time of injury",
					value: "injuryTime"
				},
				{
					text: "Supervisor",
					value: "supervisor.name"
				},
				{
					text: "Injury Location",
					value: "injuryLocation"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.created_at": ( { item } ) => formatDate( item.created_at ),

				"item.injuryDate": ( { item } ) => formatDate( item.injuryDate ),

				"item.injuryTime": ( { item } ) => formatTime( item.injuryTime ),

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "safetyEmployeeInjury",
								params: { idReport: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							<KPdfDialog
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>picture_as_pdf</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>
													Printable PDF
												</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								src={`safety/employee-injury-reports/${item.id}`}
								title="Employee Injury Report"
							></KPdfDialog>
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			} }
		></KDataTable>;
	}
} );
